<template>
  <div class="kids-details">
    <div class="kids-details-top">
      <div class="kids-details-top-img">
        <img :src="banner.imgUrl" alt="" width="100%">
      </div>
      <div class="kids-details-content">
        <!-- 关于儿童画廊 -->
        <div class="kids-details-about">
          <h2 class="kids-details-about-title">{{ aboutObj.name }}</h2>
          <span v-html="aboutObj.content"></span>
        </div>
        <!-- 内容 -->
        <div class="kids-details-about" v-for="(item,index) in aboutList" :key="index">
          <!-- <div class="kids-detail-title-bg">
            <div class="kids-detail-title-triangle"></div>
            <div class="kids-detail-title-race">{{ item.name }}</div>
          </div> -->

          <div class="kids-detail-title-test">
            <div class="kids-detail-title-test-line"></div>
            <div class="kids-detail-title-test-bg">
              <div class="kids-detail-title-triangle"></div>
              <div class="kids-detail-title-race">{{ item.name }}</div>
            </div>
          </div>

          <span v-html="item.content"></span>
          <div class="kids-detail-line"></div>
          <div>
<!--            <div class="kids-detail-pic-box" v-for="(items,indexs) in item.zuopinList" :key="indexs"> -->
<!--              <div class="kids-detail-pic-title">
                <img src="@/assets/img/student-title.png" alt="">
                <h2>{{ items.name }}</h2>
              </div> -->
              <div class="kids-detail-pic-box">
                <div  class="kids-detail-container" v-if="isMobile=='pc'">
                  <img v-for="(item,indexs) in item.zuopinList" :src="item.imgUrl" alt="">
                </div>
                <div class="kids-detail-container-mobile" v-if="isMobile == 'mobile'">
                  <img v-for="(item,indexs) in item.zuopinList" :src="item.imgUrl" alt="">
                </div>
                <div class="kids-look-all">
                  <div class="kids-look-all-title" @click="toJump(item.id,item.name) ">{{ $t('View') }}<i class="el-icon-right"></i></div>
                </div>
              </div>

<!--            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="kids-details-top-introduce" v-if="isMobile=='pc'">
        <h2>{{ $t('Foreword') }}</h2>
        <span v-html="foreword.content"></span>
      </div> -->
	    <!-- 新增 -->
      <!-- <div class="kids-details-top-introduce-mobile" v-if="isMobile=='mobile'">
        <h2>{{ $t('Foreword') }}</h2>
        <span v-html="foreword.content"></span>
      </div> -->
    </div>
    
   
  </div>
</template>
<script>
import groupGalleryList from './componets/groupGalleryList/index.vue'
import { mapState } from 'vuex'
import { listInfo, listBannerByModuleId, pageInfo,listKids } from '@/api/index';
export default {
  components: {
    groupGalleryList
  },
  computed: {
    ...mapState(['screenWidth']),
	isMobile() {
	    const userAgentInfo = navigator.userAgent;
	    const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
	    for (let i = 0; i < agents.length; i++) {
	        if (userAgentInfo.indexOf(agents[i]) > -1) {
	            return 'mobile'; // 移动端
	        }
	    }
	    return 'pc'; // PC端
	}
  },
  data() {
    return {
		id:0,
      banner: {},
      foreword: {},
      juryList: [],
      primarySchool: [],
      middleSchool: [],
      aboutObj:{
        name:'',
        content:''
      },
      aboutList:[]
    }
  },
  mounted() {
	this.id = this.$route.query.id;
    this.getBanner()
    this.listKids()
    // this.getForeword()
    this.getJury()
    // this.getPrimarySchool()
    // this.getMiddleSchool()
  },
  methods: {
    getBanner() {
      const formData = new FormData();
      formData.append("moduleId", 6);
      listBannerByModuleId(formData).then(res => {
        if (res.data && res.data != null) {
          this.banner = res.data[0];
        }
      })
    },

    toJump(id,title) {
      this.$router.push({
        path: '/kidsGalleryDetail',
        query: {
	      id: id,
	      title: title
        },
      });
    },
    

    listKids() {
		const formData = new FormData();
		formData.append("id", this.id);
      listKids(formData).then(res => {
        if (res.data && res.data != null) {
          this.aboutObj.name = res.data.name;
          this.aboutObj.content = res.data.content;
          this.aboutList = res.data.zuopinList
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.kids-details {
  background: #fff;
  .kids-details-top {
    width: 100%;
    // background-color: #fafafb;
    .kids-details-content {
      .kids-details-about{
        width: 80%;
        margin: 0 auto;
        .kids-details-about-title{
          font-size: 2.25rem;
          padding: 1rem 0;
          text-align: center;
        }
        .kids-detail-title-test{
          display: flex;
          align-items: center;
          margin: 3rem 0 2.2rem;
          .kids-detail-title-test-line{
            width: 0.55rem;
            height: 2.4rem;
            border-top-left-radius: 0.3rem;
            background: #BA000E;
          }
          .kids-detail-title-test-bg{
            background: #BA000E;
            box-shadow: 0.25rem 0.25rem #dac895;
            color: #fff;
            height: 2.4rem;
            border-top-right-radius: 0.3rem;
            border-bottom-right-radius: 0.3rem;
            display: flex;
            align-items: center;
            margin-left: 0.25rem;
            padding: 0 1rem;
            .kids-detail-title-triangle{
              width: 0;
              height: 0;
              border-top: 0.4rem solid transparent;
              border-bottom: 0.4rem solid transparent;
              border-left: 0.7rem solid #ffffff;
            }
            .kids-detail-title-race{
              margin-left: 3px;
              font-weight: 1000;
              font-size: 1.3rem;
            }
          }
        }

        .kids-detail-title-bg{
          background-image: url(@/assets/img/title-bg.png);
          background-repeat: no-repeat;
          background-size: contain;
          // width: 9.25rem;
          height: 2.4rem;
          font-size: 1.3rem;
          color: #fff;
          display: flex;
          align-items: center;
          padding-left: 1.4rem;
          // justify-content: center;
          margin: 3rem 0 2.2rem;
          .kids-detail-title-triangle{
            width: 0;
            height: 0;
            border-top: 0.4rem solid transparent;
            border-bottom: 0.4rem solid transparent;
            border-left: 0.7rem solid #ffffff;
          }
          .kids-detail-title-race{
            margin-left: 3px;
            font-weight: 1000;
          }
        }
        .kids-detail-line {
          height: 0.3rem;
          width: 100%;
          background: #BA000E;
          margin: 2.7rem 0;
        }

        .kids-detail-pic-box{
          .kids-detail-pic-title{
            background-image: url(@/assets/img/student-bg.png);
            background-repeat: no-repeat;
            background-size: 10rem;
            display: flex;
            align-items: center;
            margin-bottom: 2.7rem;
            img{
              width: 1.2rem;
              height: 1rem;
            }
            h2{
              font-size: 1.2rem;
              font-weight: 800;
              margin-left: 0.4rem;
            }
          }
          .kids-detail-container{
            display: flex;
            flex-wrap: wrap;
            // overflow-x: auto; /* 水平滚动条 */
            overflow-y: scroll; /* 隐藏垂直滚动条 */
            scrollbar-width: none; /* 隐藏滚动条 */;
            // height:28.5rem;
            min-height: 9.4rem;
            max-height: 28.5rem;
            img{
              flex: 0 0 auto; /* 不伸缩，固定宽度 */
              width: (100% / 5) - 0.2%; /* 每个项目的宽度 */
              height: 9.4rem;
              margin-right: 0.1rem; /* 项目之间的间隔 */
              margin-top: 0.1rem;
              text-align: center;
              object-fit: cover;
              // line-height: 100px; /* 行高与宽度相同，使内容垂直居中 */
            }
          }
          .kids-detail-container-mobile{
            display: flex;
            flex-wrap: wrap;
            overflow-y: auto; /* 隐藏垂直滚动条 */
            // height: 240px;
            min-height: 80px;
            max-height: 240px;
            img{
              width: (100% / 4) - 1%; /* 每个项目的宽度 */
              height: 80px;
              margin-right: 0.1rem; /* 项目之间的间隔 */
              margin-top: 0.1rem;
              object-fit: cover;
            }
          }
          .kids-look-all{
            padding: 2.4rem 0;
            .kids-look-all-title{
              background: #BA000E;
              width: 7rem;
              height: 2rem;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 1rem;
              margin: 0 auto;
              color: #fff;
              font-size: 0.8rem;
            }
          }

        }

      }
    }

    .kids-details-top-img {
    }
    .kids-details-top-introduce {
      width: 90%;
      box-sizing: border-box;
      padding: 0 4rem 3rem;
      padding-bottom: 2.5rem;
      // padding: 3rem;
      // background-color: white;
      // border-radius: 0.5rem;
      font-size: 1rem;
      line-height: 2rem;
      margin: 0 auto;
      h2 {
        text-align: center;
      }
    }
	.top-mobile{
    width: 100%;
		padding-top: 0!important;
		padding-bottom: 0!important;
    padding: 3rem 12.5%;
	}
	.kids-details-top-introduce-mobile {
	  width: 100%;
	  box-sizing: border-box;
	  padding: 0 18px;
	  // padding-bottom: 2.5rem;
	  // padding: 3rem;
	  // background-color: white;
	  // border-radius: 0.5rem;
	  font-size: 1rem;
	  line-height: 2rem;
	  h2 {
	    text-align: center;
	  }
	}
  }
  .kids-details-bottom {
    // background-color: #f6f6f6;
    width: 100%;
    padding: 3rem 12.5%;
    box-sizing: border-box;
    .kids-details-bottom-title {
      height: 1.5rem;
      line-height: 1.5rem;
      .title-symbol {
        width: 100%;
        background-color: #2c4b8e;
        width: 1.3rem;
        height: 1.5rem;
        float: left;
      }
    }
  }
}
.jury-top {
  text-align: center;
  line-height: 1rem;
  .jury-top-introduce {
    line-height: 1.7rem;
    text-align: left;
    font-size: 0.9rem;
    font-weight: 500;
    word-wrap: break-word;
    word-break: break-all;
    margin-bottom: 2rem;
  }
}
::v-deep .el-divider--horizontal {
  margin: 1rem 0;
}
.kid-bottom-bg {
  background: url(@/assets/img/kid-bottom-bg.png) no-repeat;
  background-size: 100% 50%;
  width: 100%;
  background-position: bottom;
}
</style>